import { combineReducers } from 'redux'

import configReducer from './config/reducer'
import invitationsReducer from './invitations/reducer'
import ordersReducer from './orders/reducer'
import territoriesReducer from './territories/reducer'
import tradesReducer from './tradeTypes/reducer'
import tosCheckReducer from './tosCheck/reducer'
import userReducer from './user/reducer'
import userReferralsReducer from './userReferrals/reducer'
import vendorsReducer from './vendors/reducer'
import filesReducer from './files/reducer'

import { ConfigType } from './config/types'
import { InvitationsType } from './invitations/types'
import { OrdersType } from './orders/types'
import { TerritoriesType } from './territories/types'
import { TradeTypes } from './tradeTypes/types'
import { TosCheckType } from './tosCheck/types'
import { UserType } from './user/types'
import { UserReferralsType } from './userReferrals/types'
import { VendorsType } from './vendors/types'
import { FilesType } from './files/types'

export interface State {
  config: ConfigType
  invitations: InvitationsType
  orders: OrdersType
  territories: TerritoriesType
  trades: TradeTypes
  tosCheck: TosCheckType
  user: UserType
  userReferrals: UserReferralsType
  vendorsReferrals: VendorsType
  files: FilesType
}

const rootReducer = combineReducers({
  config: configReducer,
  invitations: invitationsReducer,
  orders: ordersReducer,
  territories: territoriesReducer,
  tradeTypes: tradesReducer,
  tosCheck: tosCheckReducer,
  user: userReducer,
  userReferrals: userReferralsReducer,
  vendors: vendorsReducer,
  files: filesReducer,
})

export default rootReducer
